export default response => {
	const error = new Error(response.statusText || response.status);
	error.response = response;
	return error;
};
